import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addFoodToFavouriteRestaurent } from '../../redux/features/WishList/wishlistSlice';
import { Link } from 'react-router-dom';
const FavouriteRestaurent = () => {
    const restaurentist = useSelector((state) => state.wishlist.restaurentist);
    const dispatch = useDispatch();

    // Handle Add to favourite
    const handleAddFoodToWishlist = async (menu) => {
        try {
            dispatch(addFoodToFavouriteRestaurent(menu))
        } catch (error) {
        }
    }

    return (
        <>
            {
                restaurentist?.length > 0 ? (
                    restaurentist?.map((arr, index) => {
                        return (
                            <div key={arr.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="restaurant-card">
                                    <div className="restaurant-img">
                                        <Link to={`/restaurent-list/${arr?.id}`}>
                                            <img src={arr?.restaurant_image_single} alt="restaurant_image_single" />
                                        </Link>
                                        <button onClick={() => handleAddFoodToWishlist(arr)} className="fav-btn">
                                            <i className={restaurentist.some((item) => item.id === arr.id) ? "fas fa-heart text-danger" : "far fa-heart"} />
                                        </button>
                                    </div>
                                    <div className="restaurant-content">
                                        <h5>{arr.restaurant_name}</h5>
                                        <div className="restaurant-label">
                                            <p>
                                                <span>
                                                    <i className="fas fa-stopwatch me-1" />
                                                    {arr.delivery_time}
                                                </span>
                                                <span>{arr.distance}</span>
                                            </p>
                                            <span className="rating">
                                                <i className="fas fa-star me-1" />
                                                {arr.rating}
                                            </span>
                                        </div>
                                        <p className="text-danger">
                                            <i className="fas fa-badge-percent me-1" />
                                            20 % OFF up to ₹500
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <p className='text-center text-danger'>No Restaurants Found</p>
                )
            }

        </>
    )
}

export default FavouriteRestaurent